import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';
import CreateTiers from './CreateTiers.js'; //component for creating new tiers
import EditTiers from './EditTiers.js'; //component for editing current tiers
import Modal from 'react-modal';
import loader from '../asset/img/loader.gif';

export default class ManageTiers extends Component {
	constructor(props){
		super(props);
		this.state = {rows:6,newTiers:[],editTiers:[],failedTiers:[],loading:false,modalIsOpen:false,modalPrompt:'',success:false};
		this.addRows = this.addRows.bind(this);
		this.onCreate = this.onCreate.bind(this);
		this.onEdit = this.onEdit.bind(this);
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
	}

	loadingFunc(loading){ //method to open modal and display loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false});
		}
	}

	addRows(){ //method to add more rows for creating tiers
		let rows = this.state.rows+3;
		this.setState({rows:rows});
	}

	onCreate(tiers){ //method grabs all new tier information from each instance of CreateTiers component and adds it to the state, passed down as a prop
		this.setState(oldState => ({newTiers:[...oldState.newTiers,tiers]}));
	}

	onEdit(tiers){ //method grabs all edited tier information from each instance of EditTiers component and adds it to the state,passed down as a prop
		this.setState(oldState => ({editTiers:[...oldState.editTiers,tiers]}));
	}

	openModal(){ //open the modal
		this.setState({modalIsOpen:true});
	}

	closeModal(){ //method for closing the modal
		if(this.state.modalPrompt === 'Tiers created successfully!' || this.state.modalPrompt === 'Tiers updated successfully!'){
			this.props.reset("tiers"); //retrieve new/edited tier information for DB
		}else{
			this.props.revertSave();
		}
		this.setState({modalIsOpen:false,modalPrompt:'',success:false,newTiers:[],failedTiers:[],editTiers:[]}); //clear state
	}

	componentDidUpdate(prevProps,prevState){
		if(this.props.create && this.state.newTiers !== prevState.newTiers && this.state.newTiers.length !== 0){ //if user has chosen to create/save new tiers
			this.loadingFunc(true);
			let newTiers = this.state.newTiers;
			let failures = [];
			let failed = false;
			let newTierscheck = [];
			let alreadyExists = [];
			for(let i = 0;i<newTiers.length;i++){ //loop through and validate each new tier
				if(newTiers[i].tier === '' || newTiers[i].points === ''){ //make sure all tier information is filled out (points and tier number)
					failures.push(newTiers[i]);
				}
				for(let j = 0;j<newTiers.length;j++){ //make sure that the user is not creating duplicate tiers
					if(i!==j && newTiers[i].tier === newTiers[j].tier){
						newTierscheck.push(newTiers[i].index);
					}
				}
				this.props.tiers.forEach((t)=>{ //make sure that tiers being created do not already exist
					if(Number(newTiers[i].tier) === Number(t.tier)){
						alreadyExists.push(newTiers[i]);
					}
				});
			}
			if(newTierscheck.length < 1 && failures.length < 1 && alreadyExists.length < 1){ //if all three types of the above validation were passed, create the new tiers
				axios.all(newTiers.map(tiers=>{
						return (axios({
										method:'post',
										url:path,headers:{'Content-Type':'application/json'},
										data:{endpoint:'create',table:'tiers',misc:'create',firstID:tiers.tier,secondID:this.props.year,status:this.props.app,quantity:tiers.points}
									})
								  )
					})).then(()=>{
					this.setState({failedTiers:[],newTiers:[]},function(){
						this.loadingFunc(false);
						this.setState({success:true,modalPrompt:'Tiers created successfully!'});
					});
				});
			}else{ //one or more of the above validations were not passed

				let prompt = '';
				if(alreadyExists.length > 0){ //one or more tier already exists
					prompt = 'The following tiers already exist for the current year: ';
					prompt += alreadyExists[0].tier;
					let tID = alreadyExists[0].index.toString()+"_tier";
					document.getElementById(tID).style.borderColor="red";
					if(alreadyExists.length > 1){
						for(let k=1;k<alreadyExists.length;k++){
							prompt += ", "+alreadyExists[k].tier
							tID = alreadyExists[k].index.toString()+"_tier";
							document.getElementById(tID).style.borderColor="red";
						}
					}
					prompt += ". ";
				}

				let tierID;
				if(newTierscheck.length > 0){ //user is attempting to create duplicate tiers
					newTierscheck.forEach((duplicate)=>{
						tierID = duplicate.toString()+"_tier";
						document.getElementById(tierID).style.borderColor = "red";
					});
					prompt += 'Duplicate tiers are not permitted. ';
				}
				if(failures.length > 0){ //one or more tier is not completely filled out
					prompt += 'Each tier must be completely filled out or completely blank. '
				}
				this.setState({modalPrompt:prompt,newTiers:[]},function(){
					this.loadingFunc(false);
				});
				this.props.revertSave();
			}
		}else if(this.props.create && this.props.save && prevState.newTiers === this.state.newTiers && this.state.newTiers.length === 0 && this.state.modalPrompt === ''){ //user hit submit when there was no information entered
			this.setState({modalPrompt:'Please enter at least one tier.'},function(){
				this.openModal();
			});
		}else if(this.props.edit && this.state.editTiers !== prevState.editTiers && this.state.editTiers.length !== 0){ //user has chosen to save edited tier information
			this.loadingFunc(true);
			let editTiers = this.state.editTiers;
			let failures = [];
			for(let i=0;i<editTiers.length;i++){ //loop through and make sure that edited tier information is filled out correctly
				if(editTiers[i].quantity === '' || editTiers[i].quantity === 0){
					failures.push(editTiers[i]);
				}
			}
			if(failures.length < 1){ //if all values are correct, update tier information in DB
				axios.all(editTiers.map(tiers=>{
					let params = {endpoint:'create',table:'tiers',...tiers};
					return (axios({
										method:'post',
										url:path,headers:{'Content-Type':'application/json'},
										data:params
									}).catch((error)=>{
										failures.push(tiers);
									})
								  )
				})).then(()=>{
					this.setState({failedTiers:failures,editTiers:[]},function(){
						let modalPrompt;
						if(failures.length < 1){
							modalPrompt = 'Tiers updated successfully!';
						}else{
							modalPrompt = 'There seems to have been a problem during editing.';
						}
						this.setState({modalPrompt:modalPrompt},function(){
							this.loadingFunc(false);
						});
					});
				});
			}else{
				this.setState({modalPrompt:'Cannot have blank fields.'},function(){
					this.loadingFunc(false);
				});
			}
		} 
	}

	render(){
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'400px',
		    minWidth:'300px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			}, 
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			} 
		};
		const pStyle = "fl w-33 tc f4 pb1";
		let tiers;
		let priceType = this.props.app === "lov"?"Points: ":"Max Price: $";
		if(this.props.tiers !== undefined){
			if(this.props.tiers.length>0){
				if(this.props.tiers !== undefined && !((this.props.create) || (this.props.edit))){ //display all current tier information for selected year
					tiers = this.props.tiers.map((tiers)=>{
					return <li className="fl w-100 bb b--light-silver" key={tiers.ID}><p className={pStyle}>Tier: {tiers.tier}</p><p className={pStyle}>{priceType}{tiers.points}</p><p className={pStyle}>Status: {tiers.tier_status}</p></li>
					});
				}else if(this.props.create){ //display CreateTiers components
					tiers = [];
					for(let i=0;i<this.state.rows;i++){
						tiers.push(<li key={i} id={i}><CreateTiers id={i} onSave={this.onCreate} success={this.state.success} save={this.props.save} app={this.props.app}/></li>);
					}
				}else if(this.props.edit){ //display EditTiers components
					tiers = this.props.tiers.map((tiers)=>{
						return <li key={tiers.ID}><EditTiers tiers={tiers} success={this.state.success} id={tiers.ID} onSave={this.onEdit} save={this.props.save} app={this.props.app}/></li>;
					});
				}
			}else{ //there are no tiers for the current year selected
				if(this.props.create){ //display CreateTiers components
					tiers = [];
					for(let i=0;i<this.state.rows;i++){
						tiers.push(<li key={i} id={i}><CreateTiers id={i} onSave={this.onCreate} success={this.state.success} save={this.props.save} app={this.props.app}/></li>);
					}
				} else {
					tiers =  <li><p className="w-100 f3 tc">There is nothing to view at this time.</p></li>;
				}
			}
		}
		let modalContent;
		if(this.state.loading){ //display loading gif
			modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
		}else{ //display message
			modalContent = <p className="b navy f4 tc">{this.state.modalPrompt}</p>;
		}
		return(
			<div style={{maxWidth:'90%',margin:'auto',height:'100%'}} className="pb2">
				<ul className="list pb3">
					{tiers}
				</ul>
				<div>
					<Modal
			          isOpen={this.state.modalIsOpen}
			          style={customStyles}
			          contentLabel="loading/message"
			          shouldCloseOnOverlayClick={false}
			          shouldCloseOnEsc={false}
			        >
			        <div className="fl w-100 tr pb2">
			        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
			        </div>
			        {modalContent}
			        </Modal>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ManageTiers.js